import { render } from "./MyBox.vue?vue&type=template&id=0ecc0b6d&scoped=true"
import script from "./MyBox.vue?vue&type=script&lang=js"
export * from "./MyBox.vue?vue&type=script&lang=js"

import "./MyBox.vue?vue&type=style&index=0&id=0ecc0b6d&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecc0b6d"]])

export default __exports__